import React, { useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { ChannelData } from '../../utils/dashboardData';
interface SalesByChannelProps {
  data: ChannelData[];
}
const SalesByChannel: React.FC<SalesByChannelProps> = ({
  data
}) => {
  const [metric, setMetric] = useState<'value' | 'count'>('value');
  const formatYAxis = (tickItem: number) => {
    if (metric === 'value') {
      if (tickItem >= 1000000) return `₨${(tickItem / 1000000).toFixed(1)}M`;
      if (tickItem >= 1000) return `₨${(tickItem / 1000).toFixed(0)}k`;
      return `₨${tickItem}`;
    }
    return tickItem.toString();
  };
  const CustomTooltip = ({
    active,
    payload,
    label
  }: any) => {
    if (active && payload && payload.length) {
      const total = payload.reduce((sum: number, entry: any) => sum + entry.value, 0);
      return <div className="bg-white/90 backdrop-blur-md p-4 border border-slate-200 shadow-xl rounded-xl min-w-[220px]" data-id="element-202">
          <p className="font-semibold text-slate-900 mb-3 pb-2 border-b border-slate-100" data-id="element-203">
            {label}
          </p>
          <div className="space-y-2" data-id="element-204">
            {payload.map((entry: any, index: number) => <div key={index} className="flex items-center justify-between text-sm" data-id="element-205">
                <div className="flex items-center space-x-2" data-id="element-206">
                  <div className="w-2.5 h-2.5 rounded-sm" style={{
                backgroundColor: entry.color
              }} data-id="element-207"></div>
                  <span className="font-medium text-slate-600" data-id="element-208">
                    {entry.name}
                  </span>
                </div>
                <span className="font-bold text-slate-900" data-id="element-209">
                  {metric === 'value' ? `₨${entry.value.toLocaleString()}` : entry.value.toLocaleString()}
                </span>
              </div>)}
          </div>
          <div className="mt-3 pt-3 border-t border-slate-100 flex justify-between items-center text-sm" data-id="element-210">
            <span className="font-semibold text-slate-700" data-id="element-211">Total</span>
            <span className="font-bold text-indigo-600" data-id="element-212">
              {metric === 'value' ? `₨${total.toLocaleString()}` : total.toLocaleString()}
            </span>
          </div>
        </div>;
    }
    return null;
  };
  return <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 h-full flex flex-col" data-id="element-213">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-8 gap-4" data-id="element-214">
        <div data-id="element-215">
          <h2 className="text-lg font-bold text-slate-900" data-id="element-216">Sales by Channel</h2>
          <p className="text-sm text-slate-500 font-medium mt-1" data-id="element-217">
            Distribution across methods
          </p>
        </div>

        <div className="flex bg-slate-50 p-1 rounded-xl border border-slate-200/60 self-start sm:self-auto" data-id="element-218">
          <button onClick={() => setMetric('value')} className={`px-3 py-1.5 text-sm font-medium rounded-lg transition-all duration-200 ${metric === 'value' ? 'bg-white text-indigo-600 shadow-sm border border-slate-200/50' : 'text-slate-500 hover:text-slate-800'}`} data-id="element-219">
            Value
          </button>
          <button onClick={() => setMetric('count')} className={`px-3 py-1.5 text-sm font-medium rounded-lg transition-all duration-200 ${metric === 'count' ? 'bg-white text-indigo-600 shadow-sm border border-slate-200/50' : 'text-slate-500 hover:text-slate-800'}`} data-id="element-220">
            Count
          </button>
        </div>
      </div>

      <div className="flex-1 min-h-[250px] w-full" data-id="element-221">
        <ResponsiveContainer width="100%" height="100%" data-id="element-222">
          <BarChart data={data} margin={{
          top: 5,
          right: 0,
          left: 0,
          bottom: 5
        }} data-id="element-223">
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#F1F5F9" data-id="element-224" />
            <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
            fill: '#94A3B8',
            fontSize: 12,
            fontWeight: 500
          }} dy={10} data-id="element-225" />
            <YAxis axisLine={false} tickLine={false} tick={{
            fill: '#94A3B8',
            fontSize: 12,
            fontWeight: 500
          }} tickFormatter={formatYAxis} dx={-10} data-id="element-226" />
            <Tooltip content={<CustomTooltip data-id="element-228" />} cursor={{
            fill: '#F8FAFC'
          }} data-id="element-227" />
            <Legend verticalAlign="bottom" height={36} iconType="circle" wrapperStyle={{
            fontSize: '13px',
            fontWeight: 500,
            color: '#64748B',
            paddingTop: '20px'
          }} data-id="element-229" />
            <Bar dataKey="pos" name="POS" stackId="a" fill="#1E3A8A" radius={[0, 0, 0, 0]} data-id="element-230" />
            <Bar dataKey="softPos" name="SoftPOS" stackId="a" fill="#4F46E5" data-id="element-231" />
            <Bar dataKey="mobilePos" name="Mobile POS" stackId="a" fill="#7C3AED" data-id="element-232" />
            <Bar dataKey="eCommerce" name="E-Commerce" stackId="a" fill="#0D9488" data-id="element-233" />
            <Bar dataKey="raastQr" name="RAAST QR" stackId="a" fill="#16A34A" data-id="element-234" />
            <Bar dataKey="raastRtp" name="RAAST RTP" stackId="a" fill="#D97706" radius={[4, 4, 0, 0]} data-id="element-235" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>;
};
export default SalesByChannel;